var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11H16L19 22L14 23L11 11Z",
    fill: "#3F3E9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11H8L5 22L10 23L13 11Z",
    fill: "#3F3E9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0L13.9283 2.06541L16.7023 1.52786L17.0483 4.33222L19.6085 5.52786L18.24 8L19.6085 10.4721L17.0483 11.6678L16.7023 14.4721L13.9283 13.9346L12 16L10.0717 13.9346L7.29772 14.4721L6.95173 11.6678L4.39155 10.4721L5.76 8L4.39155 5.52786L6.95173 4.33222L7.29772 1.52786L10.0717 2.06541L12 0Z",
    fill: "#ADC4D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2L13.4462 3.54906L15.5267 3.1459L15.7862 5.24917L17.7063 6.1459L16.68 8L17.7063 9.8541L15.7862 10.7508L15.5267 12.8541L13.4462 12.4509L12 14L10.5538 12.4509L8.47329 12.8541L8.2138 10.7508L6.29366 9.8541L7.32 8L6.29366 6.1459L8.2138 5.24917L8.47329 3.1459L10.5538 3.54906L12 2Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3955 11.4619H14.6455V11.2119V9.94238V9.69238H14.3955H12.145L12.6987 9.05325C13.1861 8.56562 13.547 8.1689 13.7749 7.86625C14.006 7.56035 14.1815 7.26245 14.296 6.97272L14.2964 6.97175C14.4116 6.67655 14.4697 6.37233 14.4697 6.06055C14.4697 5.34053 14.2412 4.75458 13.7572 4.3422C13.2829 3.93538 12.6258 3.75 11.8223 3.75C11.3061 3.75 10.8319 3.86272 10.405 4.09232C9.9784 4.32177 9.64175 4.64329 9.39995 5.05455C9.15865 5.46168 9.03809 5.90774 9.03809 6.3877V6.6377H9.28809H10.9385H11.1885V6.3877C11.1885 6.1105 11.2557 5.90039 11.374 5.74031L11.374 5.74031L11.375 5.73884C11.4875 5.58414 11.618 5.51953 11.7832 5.51953C11.981 5.51953 12.097 5.57893 12.1725 5.66922C12.2541 5.76674 12.3145 5.93286 12.3145 6.20703C12.3145 6.33665 12.2649 6.51539 12.1345 6.75138C12.0059 6.98399 11.8081 7.25547 11.5351 7.56668L9.25343 9.96539L9.18457 10.0378V10.1377V11.2119V11.4619H9.43457H14.3955Z",
    fill: "#F9F9F9",
    stroke: "#171C2B",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/Silver.c7f59fe92f1f213e1a875ab277252de8.svg";
export { ForwardRef as ReactComponent };